
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/person/[slug]",
      function () {
        return require("private-next-pages/person/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/person/[slug]"])
      });
    }
  